import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {Popover, PopoverBody} from 'reactstrap';
import ReactSelect from 'react-select';

import sessionStore from '../../../../services/session/SessionStore';
import reviewResponseConfiguration from '../../../../services/review/ReviewResponseConfiguration';
import ReviewSummary from '../../../reviews/components/ReviewSummary';
import RespondToReviewStore from "../../../../services/review/RespondToReviewStore";
import GoToActionButton from "./GoToActionButton";
import {Spinner} from '../../../../components'
import ReviewResponseTemplateStore from "../../../../services/review/ReviewResponseTemplateStore";
import {recordEvent} from '../../../app/plugins/metricPlugin';
import {analyticsTaskData} from '../../analyticsHelper'
import reactSelectStyles from '../../../../services/config/reactSelect/reactSelectStyles';
import reactSelectTheme from '../../../../services/config/reactSelect/reactSelectTheme';

const CredsMessage = {
  MISSING_GOOGLE: "MISSING_GOOGLE",
  UNSUPPORTED: "UNSUPPORTED",
  REQUIRES_CONFIG: "REQUIRES_CONFIG",
  MISSING: "MISSING"
};


// TODO - perhapse make this more generic to it can be used in the reviews page when refactored, will need to pass in response templates as a provider
const RespondToReview = inject("taskStore")(observer(class RespondToReview extends Component {
  rtrStore;
  rtrTemplatesStore;
  templateRef;

  constructor(props) {
    super(props);
    this.state = {
      isPopOverOpened: false
    }
    this.templateRef = React.createRef()
  }

  componentWillMount() {
    const { entity: { review }} = this.props;
    this.rtrStore = new RespondToReviewStore(review);
    this.rtrTemplatesStore = new ReviewResponseTemplateStore();
    this.rtrTemplatesStore.loadTemplates();
    reviewResponseConfiguration.loadRespondableListings();
  }

  togglePop = () => {
    this.setState({isPopOverOpened: !this.state.isPopOverOpened});
  }

  getCredsMessage(type){
    switch(type){
      case CredsMessage.MISSING_GOOGLE:
        return <span>User credentials are needed to respond to this review. {sessionStore.hasUserPermission("ManageExternalAccounts") && <span>If you have not added your credentials, please visit the  <a href="#/admin/v2/credentials">External Accounts</a>  page to enter your Google My Business credentials. If you have previously added your credentials, please check that the location is not missing, marked as unverified, or marked as a duplicate in your Google My Business account. It can take up to 24 hours for your Google My Business credentials to sync with the dashboard.</span>}</span>
      case CredsMessage.MISSING:
        return <span>User credentials are needed to respond to this review. {sessionStore.hasUserPermission("ManageExternalAccounts") && <span>Please visit the <a href="#/admin/v2/credentials">External Accounts</a> page to enter your credentials for this provider.</span>}</span>
      case CredsMessage.UNSUPPORTED:
        return <span>Review responses not yet supported from this provider</span>
      case CredsMessage.REQUIRES_CONFIG:
        return <span>Contact support to enable review responses for this provider.</span>
    }
  }


  submitReviewResponse(){
    this.rtrStore.submitReviewResponse().then((resp) => {
      this.props.taskStore.onResponseSubmit(resp);
      this.props.taskStore.reloadTask();
      if(this.templateRef && this.templateRef.current){
        //clears the selected template
        try{
          this.templateRef.current.setState({ value: undefined})
        }catch(ex){}
      }
      recordEvent("Workflow Review Responded")
    });
  }

  updateReviewResponse = (response, publish) => {
    this.rtrStore.updateReviewResponse(response, publish).then((updated) => {
      recordEvent("Workflow Review Response Edited");
      return this.props.taskStore.onResponseUpdate(updated);
    });
  };

  rejectReviewResponse = (response, reason) => {
    this.rtrStore.rejectReviewResponse(response, reason).then(() => {
      recordEvent("Workflow Review Response Rejected");
      return this.props.taskStore.onRemoveResponse(response);
    });
  };

  removeReviewResponse = (response) => {
    this.rtrStore.removeReviewResponse(response).then(() => {
      recordEvent("Workflow Review Response Removed");
      return this.props.taskStore.onRemoveResponse(response);
    });
  };

  renderResponseButton(review) {
    let respondButton;

    if(reviewResponseConfiguration.isLoading){
      respondButton = <Spinner timeout={0}  center={false} size="md"/>
    }else if(!!(reviewResponseConfiguration.isResponseAllowed(review) || reviewResponseConfiguration.isDraftResponseAllowed(review)) && sessionStore.hasUserPermission("SubmitReviewResponse") && !this.rtrStore.showRespondUI){
      respondButton = <button className="btn btn-secondary" onClick={this.rtrStore.onRespondClick}>Respond</button>
    }else{
      const providerConfig = reviewResponseConfiguration.forProvider(review.contentProvider);
      let disabledMessage;
      if(review.contentProvider === 'GOOGLE' && (review.providerReviewId === undefined || providerConfig.requiresRespondableListing)) {
        disabledMessage = this.getCredsMessage(CredsMessage.MISSING_GOOGLE);
      } else if(providerConfig.requiresRespondableListing && review.contentProvider !== 'GOOGLE') {
        disabledMessage = this.getCredsMessage(CredsMessage.MISSING);
      } else if(providerConfig.unsupported) {
        disabledMessage = this.getCredsMessage(CredsMessage.UNSUPPORTED);
      } else {
        disabledMessage = this.getCredsMessage(CredsMessage.REQUIRES_CONFIG);
      }

      respondButton =<Fragment>
        <button id="respondButton" className="btn btn-secondary" type="button" disabled={true} onMouseEnter={() => this.setState({isPopOverOpened: true})}>Respond</button>
        <Popover container="inline" isOpen={this.state.isPopOverOpened} toggle={this.togglePop} placement="auto" target="respondButton"><PopoverBody>{disabledMessage}</PopoverBody></Popover>
      </Fragment>
    }
    return respondButton;
  }

  renderReviewResponseTemplates() {
    if (this.rtrTemplatesStore.isLoading) {
      return <Spinner timeout={0} center={false} size="md"/>
    }
    const groupedTemplates = this.rtrTemplatesStore.groupedResponseTemplates;
    const templates = Object.keys(groupedTemplates).map( key => {
       return {
        label: key,
        options: groupedTemplates[key].map(template => ({ label: template.name, value: template.body }))
      };
    });

    return <ReactSelect
      styles={reactSelectStyles()}
      theme={reactSelectTheme}
      ref={this.templateRef}
      options={templates}
      onChange={(selected) => { this.rtrStore.onDraftChange(selected.value) }}
    />
  }

  renderSendPublishOrSubmitButton(review)  {
    const providerConfig = reviewResponseConfiguration.forProvider(review.contentProvider);
    if(reviewResponseConfiguration.isResponseAllowed(review)) {
      return (
        <button type="button" disabled={!this.rtrStore.responseDraft || this.rtrStore.isLoading} className="btn btn-secondary control-spacer-left" onClick={() => this.submitReviewResponse()}>{providerConfig.isReviewBuilder ? "Send" : "Publish"}</button>
      );
    }else{
      return (
        <button type="button" disabled={!this.rtrStore.responseDraft || this.rtrStore.isLoading} className="btn btn-secondary control-spacer-left" onClick={() => this.submitReviewResponse()}>Submit for Approval</button>
      );
    }
  }

  renderLowerSection(review) {
    let lowerSection;
    if(!this.rtrStore.showRespondUI){
      lowerSection = (
        <div className="row pb-4">
          <div className="col-6">
            {this.renderResponseButton(review)}
          </div>
          <div className="col-6">
            <GoToActionButton onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))} href={`#/reviews/details?reviewId=${review._id}`}>Go To Review</GoToActionButton>
          </div>
        </div>
      )
    }else{
      lowerSection = (
        <Fragment>
          <div className="row pb-4">
            <div className="col-11 mb-2 form-group">
              <textarea rows="6" className="form-control" placeholder="Write new response to this review" value={this.rtrStore.responseDraft} onChange={e => this.rtrStore.onDraftChange(e.target.value)} />
            </div>
          </div>
          <div className="row pb-4">
            <div className="col">
              <a className="btn btn-secondary" onClick={this.rtrStore.onCancelClick}>Cancel</a>
            </div>
            <div className="col-auto text-right">
              <span className="text-left" style={{width: 175, display: "inline-block"}}>{this.renderReviewResponseTemplates()}</span>
              <a className="btn btn-link-dark" onClick={() => this.rtrStore.onDraftChange("")}>Clear</a>
              {this.renderSendPublishOrSubmitButton(review)}
            </div>
          </div>
        </Fragment>
      );
    }
    return lowerSection;
  }

  render(){
    const { entity: { review }} = this.props;
    return (<Fragment>
      <ReviewSummary review={review} showResponses={true} showPublishingErrors={true} updateResponse={this.updateReviewResponse} rejectResponse={this.rejectReviewResponse} removeResponse={this.removeReviewResponse}/>
      {this.renderLowerSection(review)}
    </Fragment>);
  }
}));

export default RespondToReview;
